export enum EventType {
  PageView = 'vpageview-route',
  Global = 'global',
  Conversion = 'conversion',
  Event = 'event',
  AddToCart = 'addToCart',
  Checkout = 'checkout',
  Purchase = 'purchase',
  ProductClick = 'productClick',
  Login = 'login'
}
